export default "__VITE_ASSET__B01w_RE2__"